module.exports = __webpack_public_path__ + "img/FadLogoAudiobus.b9b03b50.png";